import { gql } from "@apollo/client";
import { ORCR_VERIFICATION_STATUS } from "../../../config/constants";

export const getSectionInfo = (props) => {
    let sectionInfo = { section: "", sub_section: "" };

    if (['credit_advice_received', 'contract_signed']?.includes(props.current_page)) {
        sectionInfo = { section: "Credit advice received", sub_section: props.name };
    }
    else if (props.current_page === 'soft_approval') {
        sectionInfo = { section: "Soft Approval Received", sub_section: "" };
    } else {
        sectionInfo = { section: "Vehicle Transfer", sub_section: props.name };
    }
    return sectionInfo;
};

export const setDocPath = ({ current_page, softApprovalDocs, doc_id, financier_id, required_counter, lead_doc_count, setSoftApprovalDocs, softApprovalDocList, lead_id, parent_id, doc_path, user_id, setSoftApprovalDocsList, vehicleAndSoftCreditDocs, handleEitherDocCondition, vehicleAndSoftCreditDocuments, setVehicleAndSoftCreditDocuments, leadDetail, setVehicleAndSoftCreditDocs }) => {
    if (current_page === "soft_approval") {
        const updatedDocs = softApprovalDocs.map((obj) => {
            if (obj.id === doc_id && obj.financier_id === financier_id) {
                if (obj.is_required === "1") required_counter++;
                return { ...obj, "lead_doc_count": lead_doc_count + 1 };
            }
            return obj;
        });
        setSoftApprovalDocs(updatedDocs);
        let lead_detail_docs = [...softApprovalDocList];
        lead_detail_docs.push({
            lead_id: Number(lead_id),
            financier_id: financier_id,
            doc_id: doc_id,
            doc_status: "2",
            parent_doc_id: parent_id,
            doc_path: doc_path,
            doc_source: "web",
            user_id: user_id,
            status: "1"
        });
        setSoftApprovalDocsList(lead_detail_docs);
    }
    else {
        //updating doc count of each document in array
        if (["credit_advice_received"].includes(current_page)) {
            const docsPresent = [doc_id, ...vehicleAndSoftCreditDocs?.map(doc => doc.doc_id)];
            handleEitherDocCondition(vehicleAndSoftCreditDocuments, docsPresent);
        }
        const updatedDocs = vehicleAndSoftCreditDocuments.map((obj) => {
            if (obj.id === doc_id) {
                if (obj.is_required === "1") required_counter++;
                return { ...obj, "lead_doc_count": lead_doc_count + 1 };
            }
            return obj;
        });
        setVehicleAndSoftCreditDocuments(updatedDocs);
        let lead_detail_docs = [...vehicleAndSoftCreditDocs];
        lead_detail_docs.push({
            lead_id: Number(lead_id),
            financier_id: leadDetail?.financier?.filter(v => v.is_proceed === "yes")[0].financier_id,
            doc_id: doc_id,
            doc_status: "2",
            parent_doc_id: parent_id,
            doc_path: doc_path,
            doc_source: "web",
            user_id: user_id,
            status: "1"
        });
        setVehicleAndSoftCreditDocs(lead_detail_docs);
    }
    return required_counter;
};

export const isPageReadOnly = (current_page, leadDetail) => {
    switch (current_page) {
        case 'soft_approval':
        case 'contract_signed':
            return !!leadDetail?.tab_status?.credit_advice_received?.contract_signing_received?.is_completed;
        case 'credit_advice_received':
            return !!leadDetail?.tab_status?.payment_verification?.is_completed;
        case 'car_handover':
            return !!leadDetail?.tab_status?.vehicle_details?.car_handover?.is_completed;
        case 'orcr_received':
            return !!leadDetail?.tab_status?.vehicle_details?.orcr_submission_to_financier?.is_completed;
        case 'orcr_verified':
            return !!leadDetail?.tab_status?.vehicle_details?.orcr_verified_by_financier?.is_completed;
        case 'orcr_sent_for_title_transfer':
            return !!leadDetail?.tab_status?.vehicle_details?.orcr_sent_for_title_transfer?.is_completed;
        case 'orcr_received_after_title_transfer':
            return !!leadDetail?.tab_status?.vehicle_details?.orcr_received_after_title_transfer?.is_completed;
        case 'orcr_sent_for_verification':
            return !!leadDetail?.tab_status?.vehicle_details?.orcr_sent_for_verification?.is_completed;
        case 'orcr_verification_status':
            return !!leadDetail?.tab_status?.vehicle_details?.orcr_verification_status?.is_completed;
        default:
            return false;
    }
};


export const generateMutationAndVariables = ({ current_page,
    commonFields,
    vehicleAndSoftCreditDocs,
    adp_type,
    finalSoftApprovalArr,
    setSoftApprovalDocsList,
    params,
    softApprovalDocList,
    leadDetail,
    softApprovalData,
}) => {
    let variables = {}, mutation = '', redirecturl = '';
    switch (current_page) {
        case 'car_handover':
            variables = {
                carHandoverInput: {
                    ...commonFields,
                    car_handover_docs: vehicleAndSoftCreditDocs || [],
                    adp_type: adp_type
                }
            };
            mutation = gql`
                        mutation saveCarHandover($carHandoverInput: CarHandoverInput!) {
                            car_handover_save(carHandoverInput: $carHandoverInput) {
                                success
                            }
                        }
                    `;
            redirecturl = `/lead-detail/orcr-recieved/${params.lead_id}`;
            break;
        case 'soft_approval':
            variables = {
                softApprovalInput: {
                    ...commonFields,
                    soft_approval_data: finalSoftApprovalArr,
                    soft_approval_docs: softApprovalDocList || []
                }
            };
            mutation = gql`
                        mutation saveSoftApproval($softApprovalInput: SoftApprovalInput!) {
                            soft_approval_save(softApprovalInput: $softApprovalInput) {
                                success
                            }
                        }
                    `;
            setSoftApprovalDocsList([]);
            break;
        case 'credit_advice_received':
            variables = {
                creditDocumentInput: {
                    ...commonFields,
                    credit_document_docs: vehicleAndSoftCreditDocs || []
                }
            };
            mutation = gql`
                        mutation saveCreditDocumentReceived($creditDocumentInput: CreditDocumentInput!) {
                            credit_document_received_save(creditDocumentInput: $creditDocumentInput) {
                                success
                            }
                        }
                    `;
            redirecturl = `/lead-detail/conract-signing-received/${params.lead_id}`;
            break;
        case 'contract_signed':
            variables = {
                contractSigningInput: {
                    ...commonFields,
                    contract_signing_docs: vehicleAndSoftCreditDocs || []
                }
            };
            mutation = gql`
                        mutation saveContractSigned($contractSigningInput: ContractSigningInput!) {
                            contract_signing_save(contractSigningInput: $contractSigningInput) {
                                success
                            }
                        }
                    `;
            redirecturl = `/lead-detail/computation-generated/${params.lead_id}`;
            break;
        case 'orcr_received':
            variables = {
                orcrReceivedInput: {
                    ...commonFields,
                    adp_type: adp_type,
                    orcr_received_docs: vehicleAndSoftCreditDocs || []
                }
            };
            mutation = gql`
                        mutation saveOrcrReceived($orcrReceivedInput: OrcrReceivedInput!) {
                            orcr_received_save(orcrReceivedInput: $orcrReceivedInput) {
                                success
                            }
                        }
                    `;
            if (leadDetail?.lead_computation_details?.orcr_docs_verification_done === "Yes")
                redirecturl = `/lead-detail/orcr-sent-for-verification/${params.lead_id}`;
            else if (leadDetail?.lead_computation_details?.title_transfer_type === "Yes")
                redirecturl = `/lead-detail/orcr-sent-for-title-transfer/${params.lead_id}`;
            else
                redirecturl = `/lead-detail/orcr-submission/${params.lead_id}`;
            break;
        case 'orcr_verified':
            variables = {
                orcrVerifiedInput: {
                    ...commonFields,
                    orcr_verified_docs: vehicleAndSoftCreditDocs || [],
                    adp_type
                }
            };
            mutation = gql`
                        mutation saveOrcrVerified($orcrVerifiedInput: OrcrVerifiedInput!) {
                            orcr_verified_save(orcrVerifiedInput: $orcrVerifiedInput) {
                                success
                            }
                        }
                    `;
            redirecturl = `/lead-detail/orcr-verfied/${params.lead_id}`;
            break;
        case 'credit_investigation_recieved':
            let softApprovalData1 = softApprovalData.map((sa) => {
                delete sa?.new_texarea;
                delete sa?.org_is_credit_investigation_received;
                return sa;
            });
            variables = {
                creditReceivedInput: {
                    ...commonFields,
                    ci_received_data: softApprovalData1,
                                
                }
            };
            mutation = gql`
                            mutation saveCrditInvestigationReceived($creditReceivedInput: CreditReceivedInput!) {
                                save_credit_investigation(creditReceivedInput: $creditReceivedInput) {
                                    success
                                }
                            }
                        `;
            let checkyes = softApprovalData?.filter((cy) => cy.is_credit_investigation_received === "yes");
            if (checkyes.length)
                redirecturl = ``;
            else
                redirecturl = `/lead-detail/credit-investigation/${params.lead_id}`;
            break;
        case 'orcr_sent_for_title_transfer':
            variables = {
                orcrSentforTransferInput: {
                    ...commonFields,
                    adp_type: adp_type,
                    orcr_sent_for_transfer_docs: vehicleAndSoftCreditDocs || []
                }
            };
            mutation = gql`
                            mutation saveOrcrSentforTransfer($orcrSentforTransferInput: OrcrSentforTransferInput!) {
                                orcr_sent_for_transfer_save(orcrSentforTransferInput: $orcrSentforTransferInput) {
                                    success
                                }
                            }
                        `;
            redirecturl = `/lead-detail/orcr-recieved-after-title-transfer/${params.lead_id}`;
            break;
        case 'orcr_received_after_title_transfer':
            variables = {
                orcrReceivedAfterTransferInput: {
                    ...commonFields,
                    adp_type: adp_type,
                    orcr_received_after_transfer_docs: vehicleAndSoftCreditDocs || []
                }
            };
            mutation = gql`
                            mutation saveOrcrReceivedAfterTransfer($orcrReceivedAfterTransferInput: OrcrReceivedAfterTransferInput!) {
                                orcr_received_after_transfer_save(orcrReceivedAfterTransferInput: $orcrReceivedAfterTransferInput) {
                                    success
                                }
                            }
                        `;
            redirecturl = `/lead-detail/orcr-submission/${params.lead_id}`;
            break;
        case 'orcr_sent_for_verification':
            variables = {
                orcrSentforVerificationInput: {
                    ...commonFields,
                    orcr_sent_for_verification_docs: vehicleAndSoftCreditDocs || []
                }
            };
            mutation = gql`
                                    mutation saveOrcrSentforVerification($orcrSentforVerificationInput: OrcrSentforVerificationInput!) {
                                        orcr_sent_for_verification_save(orcrSentforVerificationInput: $orcrSentforVerificationInput) {
                                            success
                                        }
                                    }
                                `;
            redirecturl = `/lead-detail/orcr-verification-status/${params.lead_id}`;
            break;
        case 'orcr_verification_status':
            variables = {
                orcrVerificationStatusInput: {
                    ...commonFields,
                    orcr_verification_status_reference_notes: commonFields?.orcr_verification_status_reference_notes,
                    orcr_verification_status_docs: vehicleAndSoftCreditDocs || []
                }
            };
            mutation = gql`
                mutation saveOrcrVerificationStatus($orcrVerificationStatusInput: orcrVerificationStatusInput!) {
                    orcr_verification_status_save(orcrVerificationStatusInput: $orcrVerificationStatusInput) {
                        success
                        }
                        }
                        `;
                        
            redirecturl = leadDetail?.lead_computation_details?.title_transfer_type === "Yes" && leadDetail?.lead_details?.orcr_verification_status === ORCR_VERIFICATION_STATUS.VERIFIED ? `/lead-detail/orcr-sent-for-title-transfer/${params.lead_id}` : `/lead-detail/orcr-submission/${params.lead_id}`;
            break;
        case 'saveCreditAdviceReceived':
            variables = {
                saveCreditAdviceReceivedInput: {
                    ...commonFields,
                }
            };
            mutation = gql`
            mutation SaveCreditAdviceReceived($saveCreditAdviceReceivedInput: CreditDocumentInput!) {
                saveCreditAdviceReceived(saveCreditAdviceReceivedInput: $saveCreditAdviceReceivedInput) {
                    success
                    }
                    }
                    `;
                    
            redirecturl = "";
            break;
        case 'saveExpectedContractSignedDate':
            variables = {
                saveExpectedContractSignedDateInput: {
                    ...commonFields,
                }
            };
            mutation = gql`
            mutation SaveExpectedContractSignedDate($saveExpectedContractSignedDateInput: ExpectedContractSignedDateInput!) {
                saveExpectedContractSignedDate(saveExpectedContractSignedDateInput: $saveExpectedContractSignedDateInput) {
                    success
                    }
                    }
                    `;

            redirecturl = "";
            break;
        case 'frezeeCreditAdviceReceived':
            variables = {
                ...commonFields
            };
            mutation = gql`
                        mutation FrezeeCreditAdviceReceived($lead_id: Float!, $financier_id: Float!) {
                            frezeeCreditAdviceReceived(lead_id: $lead_id, financier_id: $financier_id) {
                                message
                            }
                        }
                    `;
                                
            redirecturl = `/lead-detail/conract-signing-received/${params.lead_id}`;
            break;
        default:
    }
    return { variables, mutation, redirecturl };
};